module.exports = __webpack_public_path__ + "static/img/170810-research-team-members.b9ed061.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/170810-research-team-members.jpg
// module id = Mq3D
// module chunks = 0